<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
        <svg-icon src="./assets/images/icons/close.svg"></svg-icon>
    </button>
</div>
<div class="modal-body" style="overflow-y: auto; height: 600px;" *ngIf="isCouponDataFound==1">
    <h4 class="font-weight-normal mb-3 mb-md-4 pb-2 pb-md-3 border-bottom">Select Coupon</h4>
    <div class="row row-gap-4">
        <div class="col-12 col-md-6" *ngFor="let coupon of mainCouponList | filter:searchText | paginate: { itemsPerPage: 500,
            currentPage: page, totalItems:mainCouponList?.length }; let i=index">
            <div class="bg-white p-3 border border-light d-flex column-gap-3 h-100 modal_coupon_card"
                [ngClass]="this.pollsandsurvey.couponId === coupon.couponId && 'active'">
                <div class="custom-control custom-radio">
                    <input type="radio" [(ngModel)]="this.pollsandsurvey.couponId" class="custom-control-input"
                        name="list_name" [id]="coupon.couponId + 'list_name'" value="{{coupon.couponId}}"
                        (change)="getCouponId(coupon.couponId, coupon.couponTitle)">
                    <label [for]="coupon.couponId + 'list_name'" class="custom-control-label cursor-pointer">
                        <img [src]="coupon?.couponImage" [alt]="couponlogo" [title]="couponlogo"
                            class="modal_coupon_image">
                    </label>
                </div>
                <div class="d-flex flex-column row-gap-2 pl-3 border-left border-light">
                    <h3 class="font-weight-bold text-primary h5 mb-0 cursor-pointer">
                        {{coupon.couponTitle}}</h3>
                    <p class="small mb-0">{{coupon?.couponDescription}}</p>
                </div>
            </div>
        </div>
    </div>
    <div class="d-flex align-items-center justify-content-end column-gap-3 mt-3 mt-md-4 mt-lg-5">
        <button class="btn btn-clear" type="button" (click)="modal.dismiss()">Cancel</button>
        <button class="btn btn-primary" type="button" (click)="assignCouponData()">Assign</button>
    </div>
</div>

<div class="modal-body" style="overflow-y: auto; height: 600px;" *ngIf="isCouponDataFound==0">
    <h4 class="font-weight-normal mb-3 mb-md-4 pb-2 pb-md-3 border-bottom">Select Coupon</h4>
    <div class="row row-gap-4">
        <div class="col-12 col-md-6">
            <p>No Coupon Data Found.</p>
        </div>
    </div>
</div>